var isUndefined = function (value) {
    return value === undefined;
};
export default isUndefined;
//# sourceMappingURL=is-undefined.js.map